import './BackToMars.css';

export default function BackToMars() {
  return (
    <a className="back-to-mars" href="/">
      <span aria-hidden="true">←</span>
      Back to Mars
    </a>
  );
}
